/** Shown when the model refuses or the provider stops on a content filter. */
export const MODEL_REFUSAL_MESSAGE =
  "Dazu kann ich nichts sagen. Bitte formuliere die Frage anders.";

export function isModelRefusalFinishReason(reason: string | null | undefined): boolean {
  const value = String(reason ?? "").trim().toLowerCase();
  return value === "content-filter" || value === "refusal" || value === "content_filter";
}
